import SignInBtn from '../../Buttons/SignInBtn/SignInBtn';
import './SignInForm.css';




const SignInForm = () => {
    return ( 
        <div className="signinform">
            <form action="">
                <input type="email" name="Email" id="" placeholder="Email Address" />

                <input type="password" name="Password" id="" placeholder="Password" />

                <SignInBtn />
            </form>
        </div>
     );
}
 
export default SignInForm;